import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getDashboardStats } from '../../services/firebaseService';

export default function AdminDashboard() {
  const { t } = useTranslation();
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchStats() {
      try {
        const data = await getDashboardStats();
        setStats(data);
      } catch (err) {
        console.error('Failed to load stats:', err);
      } finally {
        setLoading(false);
      }
    }
    fetchStats();
  }, []);

  if (loading) {
    return <div className="admin-loading"><div className="spinner"></div></div>;
  }

  const cards = [
    {
      title: t('admin.blogPosts'),
      value: stats?.totalPosts || 0,
      icon: 'fas fa-blog',
      color: 'var(--color-primary)',
      link: '/admin/blogs',
    },
    {
      title: t('admin.messages'),
      value: stats?.totalContacts || 0,
      badge: stats?.unreadContacts || 0,
      icon: 'fas fa-envelope',
      color: 'var(--color-accent)',
      link: '/admin/contacts',
    },
    {
      title: t('admin.subscribers'),
      value: stats?.totalSubscribers || 0,
      icon: 'fas fa-users',
      color: 'var(--color-support)',
      link: '/admin/newsletter',
    },
    {
      title: t('admin.faqItems'),
      value: stats?.totalFaqs || 0,
      icon: 'fas fa-question-circle',
      color: 'var(--color-secondary)',
      link: '/admin/faqs',
    },
  ];

  return (
    <div className="admin-dashboard">
      <div className="admin-page-header">
        <h1>{t('admin.dashboard')}</h1>
        <p>{t('admin.welcomeMsg')}</p>
      </div>

      <div className="admin-stats-grid">
        {cards.map((card) => (
          <Link to={card.link} key={card.title} className="admin-stat-card">
            <div className="admin-stat-icon" style={{ background: card.color }}>
              <i className={card.icon}></i>
            </div>
            <div className="admin-stat-info">
              <span className="admin-stat-value">{card.value}</span>
              <span className="admin-stat-label">{card.title}</span>
            </div>
            {card.badge > 0 && (
              <span className="admin-stat-badge">{card.badge} {t('admin.new')}</span>
            )}
          </Link>
        ))}
      </div>

      <div className="admin-quick-actions">
        <h2>{t('admin.quickActions')}</h2>
        <div className="admin-actions-grid">
          <Link to="/admin/blogs/new" className="admin-action-card">
            <i className="fas fa-plus-circle"></i>
            <span>{t('admin.newPost')}</span>
          </Link>
          <Link to="/admin/faqs" className="admin-action-card">
            <i className="fas fa-plus-circle"></i>
            <span>{t('admin.addFaq')}</span>
          </Link>
          <Link to="/admin/contacts" className="admin-action-card">
            <i className="fas fa-inbox"></i>
            <span>{t('admin.viewMessages')}</span>
          </Link>
          <a href="/" target="_blank" rel="noopener noreferrer" className="admin-action-card">
            <i className="fas fa-eye"></i>
            <span>{t('admin.viewWebsite')}</span>
          </a>
        </div>
      </div>
    </div>
  );
}
